import Conditions from "@builder/components/editable/advanced/Conditions";
import HideShow from "@builder/components/editable/advanced/HideShow";
import { EditableProps } from "@builder/components/editable/editableProps";
import Backdrop from "@builder/components/editable/editor/Backdrop";
import BackgroundImage from "@builder/components/editable/editor/BackgroundImage";
import CashLedgerData from "@builder/components/editable/editor/CashLedgerData";
import EditAction from "@builder/components/editable/editor/EditAction";
import EditBarcode from "@builder/components/editable/editor/EditBarcode";
import EditTaxConfigurations from "@builder/components/editable/editor/EditTaxConfiguration";
import EditDropdownField from "@builder/components/editable/editor/EditDropdownField";
import EditIframe from "@builder/components/editable/editor/EditIframe";
import EditImage from "@builder/components/editable/editor/EditImage";
import EditMenu from "@builder/components/editable/editor/EditMenu";
import EditRadioField from "@builder/components/editable/editor/EditRadioField";
import EditSearchField from "@builder/components/editable/editor/EditSearchField";
import EditSlideout from "@builder/components/editable/editor/EditSlideout";
import EditTemplateDiv from "@builder/components/editable/editor/EditTemplateDiv";
import EmbedSection from "@builder/components/editable/editor/EmbedSection";
import EOSData from "@builder/components/editable/editor/EOSData";
import FilterTarget from "@builder/components/editable/editor/FilterTarget";
import Info from "@builder/components/editable/editor/Info";
import Payment from "@builder/components/editable/editor/Payment";
import Printer from "@builder/components/editable/editor/Printer";
import ProductQuantity from "@builder/components/editable/editor/ProductQuantity";
import CustomerQuery from "@builder/components/editable/editor/Query/CustomerQuery";
import OrderQuery from "@builder/components/editable/editor/Query/OrderQuery";
import ProductQuery from "@builder/components/editable/editor/Query/ProductQuery";
import ReceiptData from "@builder/components/editable/editor/ReceiptData";
import Search from "@builder/components/editable/editor/Search";
import SimpleCart from "@builder/components/editable/editor/SimpleCart";
import VariantOptions from "@builder/components/editable/editor/VariantOptions";
import ActiveVariant from "@builder/components/editable/style/ActiveVariant";
import ImageStyle from "@builder/components/editable/style/ImageStyle";
import ReceiptTypography from "@builder/components/editable/style/ReceiptTypography";
import BarcodeStyle from "@builder/components/editable/style/StyleBarcode";
import StyleGrid from "@builder/components/editable/style/StyleGrid";
import StyleSimpleCart from "@builder/components/editable/style/StyleSimpleCart";
import TextInput from "@builder/components/editable/style/TextInput";
import Typography from "@builder/components/editable/style/Typography";
import Variant from "@builder/components/editable/style/Variant";
import VariantGrid from "@builder/components/editable/style/VariantGrid";
import Advanced from "../../editable/advanced/Advanced";
import Button from "../../editable/editor/Button";
import EditIcon from "../../editable/editor/EditIcon";
import TextEdit from "../../editable/editor/Text";
import Background from "../../editable/style/Background";
import Borders from "../../editable/style/Borders";
import Layout from "../../editable/style/Layout";
import Size from "../../editable/style/Size";
import Spacing from "../../editable/style/Spacing";
import StyleIcon from "../../editable/style/StyleIcon";
import StyleMenuIcon from "@builder/components/editable/style/StyleMenuIcon";
import StyleMenuTypography from "@builder/components/editable/style/StyleMenuTypography";
import ReverseRow from "@builder/components/editable/style/Layout/ReverseRow";
import EditPaymentGrid from "@builder/components/editable/editor/PaymentGrid/EditPaymentGrid";
import EditPaymentGridButton from "@builder/components/editable/editor/PaymentGrid/EditPaymentButton";
import EditGrid from "@builder/components/editable/editor/PaymentGrid/EditGrid";
import DynamicDataOptions from "@builder/components/editable/advanced/dynamicDataOptions/DynamicDataOptions";
import EditCustomerNotes from "@builder/components/editable/editor/EditCustomerNotes";
import StyleContainer from "@builder/components/editable/style/StyleContainer";
import StyleFullButton from "@builder/components/editable/style/StyleFullButton";
import EditSection from "@builder/components/editable/editor/EditSection";
import EditCartActiveCustomer from "@builder/components/editable/editor/SimpleCart/ActiveCustomerEdit";
import EditCartLineItems from "@builder/components/editable/editor/SimpleCart/LineItemsEdit";
import EditCartOrderNotes from "@builder/components/editable/editor/SimpleCart/OrderNotes";
import NumpadGrid from "@builder/components/editable/style/NumpadGrid";
import ChooselinkedInputDisplayTarget from "@builder/components/editable/editor/ChooseLinkedInputTarget";
import LineStyling from "@builder/components/editable/editor/LineStyling";
import StyleSmartGrid from "@builder/components/editable/style/StyleSmartGrid";
import EditActionTile from "@builder/components/editable/editor/EditSmartGrid/EditActionTile";
import EditProductTile from "@builder/components/editable/editor/EditSmartGrid/EditProductTile";
import EditSmartGrid from "@builder/components/editable/editor/EditSmartGrid/EditSmartGrid";
import EditFolderTile from "@builder/components/editable/editor/EditSmartGrid/EditFolderTile";
import EditCategoryTile from "@builder/components/editable/editor/EditSmartGrid/EditCategoryTile";

export type EditMap = Record<string, React.FC<EditableProps>>;

export const editMap: EditMap = {
    layout: Layout,
    reverseRow: ReverseRow,
    background: Background,
    size: Size,
    spacing: Spacing,
    borders: Borders,
    advanced: Advanced,
    editText: TextEdit,
    typography: Typography,
    editIcon: EditIcon,
    editMenu: EditMenu,
    styleIcon: StyleIcon,
    button: Button,
    productQuery: ProductQuery,
    orderQuery: OrderQuery,
    customerQuery: CustomerQuery,
    editImage: EditImage,
    editAction: EditAction,
    lineStyling: LineStyling,
    simpleCart: SimpleCart,
    styleSimpleCart: StyleSimpleCart,
    backdrop: Backdrop,
    conditions: Conditions,
    hideShow: HideShow,
    info: Info,
    payment: Payment,
    printer: Printer,
    receiptData: ReceiptData,
    productTitles: ReceiptTypography,
    productPrice: ReceiptTypography,
    productSku: ReceiptTypography,
    productVariations: ReceiptTypography,
    productDescription: ReceiptTypography,
    productDiscount: ReceiptTypography,
    productTax: ReceiptTypography,
    productTotal: ReceiptTypography,
    productTotalPrice: ReceiptTypography,
    cartTotal: ReceiptTypography,
    cartPayment: ReceiptTypography,
    cartEMV: ReceiptTypography,
    cashLedgerData: CashLedgerData,
    eosData: EOSData,
    productQuantity: ProductQuantity,
    variantOptions: VariantOptions,
    variantGrid: VariantGrid,
    search: Search,
    imageStyle: ImageStyle,
    styleGrid: StyleGrid,
    numpadGrid: NumpadGrid,
    editSearchField: EditSearchField,
    filterTarget: FilterTarget,
    editTaxConfigurations: EditTaxConfigurations,
    editRadioField: EditRadioField,
    editDropdownField: EditDropdownField,
    editSlideout: EditSlideout,
    editBarcode: EditBarcode,
    barcodeStyle: BarcodeStyle,
    embedSection: EmbedSection,
    editIframe: EditIframe,
    styleContainer: StyleContainer,
    sectionEdit: EditSection,
    styleFullButton: StyleFullButton,
    editCustomerNotes: EditCustomerNotes,
    backgroundImage: BackgroundImage,
    variant: Variant,
    activeVariant: ActiveVariant,
    textInput: TextInput,
    templateDiv: EditTemplateDiv,
    styleMenuIcon: StyleMenuIcon,
    styleMenuTypography: StyleMenuTypography,
    paymentGrid: EditPaymentGrid,
    paymentGridButton: EditPaymentGridButton,
    editPaymentGrid: EditGrid,
    dynamicDataOptions: DynamicDataOptions,
    editCustomerCart: EditCartActiveCustomer,
    editLineItemsCart: EditCartLineItems,
    editOrderNotesCart: EditCartOrderNotes,
    gridConfig: NumpadGrid,
    styleText: Typography,
    chooseLinkedInputTarget: ChooselinkedInputDisplayTarget,
    styleSmartGrid: StyleSmartGrid,
    editActionTile: EditActionTile,
    editProductTile: EditProductTile,
    editCategoryTile: EditCategoryTile,
    editSmartGrid: EditSmartGrid,
    editFolderTile: EditFolderTile
};
